<template>
  <div>
    <label class="form-control-label">{{ label }}</label>
    <multiselect
      v-model="selectedBrand"
      :options="brands"
      placeholder="Selecionar marca"
      label="name"
      :selected-label="'Selecionado'"
      :loading="loading"
      @search-change="debouncedGetBrands"
      @bottom-reached="debouncedGetBrands"
      :multiple="multiple"
      track-by="id"
      :limit="1"
      :limit-text="limitText"
      :close-on-select="closeOnSelect"
      open-direction="bottom"
    >
      <template 
        v-if="multiple == true" 
        slot="beforeList"
      >
        <div 
          @click="toggleSelectAll" 
          :class="allSelected ? 'all-selected ' : 'multiple select-all-option'" 
          :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''"
        >
          <span 
            :style="allSelected ? 'font-weight: 700' : ''"
          >
            {{ allSelected ? 'desmarcar todas' : 'selecionar todas' }}
          </span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'BrandMultiselect',
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: 'Marca',
    },
    apiVersion: {
      type: String,
      required: true
    },
    filter: {
      type: [String, Object],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      brands: [],
      loading: false,
      pagination: {
        page: 1,
        per_page: 10,
      },
      getBrandsTimeout: null,
      allSelectedActive: false,
      totalBrands: null,
      totalCounter: 0,
      lastBrandQuery: null,
    };
  },
  mounted() {
    this.getBrands();
  },
  methods: {
    async getBrands(query = null) {
      this.loading = true;
      let versionApi = '', q = null;

      const requestParams = {
        page: this.pagination.page,
        per_page: this.pagination.per_page,
      }

      if (query && query.length > 0)  {
        q = {}
        q.name = query
      }

      if (this.lastBrandQuery != query) this.pagination.page = 1;
      if (this.apiVersion === 'v1')     versionApi = '/api/v1';
      if (this.apiVersion === 'v2')     versionApi = '/api/v2';
      if (q)                            requestParams.q = q;

      try {
        const response = await this.$http.secured.get(`${versionApi}/brands`, {
          params: requestParams
        });
        
        const initialBrands = response.data.brands || response.data.data || [];
        const newBrands     = initialBrands.sort((a, b) => a.name.localeCompare(b.name));

        if (!this.totalBrands) this.totalBrands = response.data.count;

        if (this.pagination.page === 1) {
          this.brands = newBrands;

          if (this.allSelectedActive) this.selectedBrand = newBrands;
        } else {
          const uniqueBrands = newBrands.filter(newBrand => !this.brands.some(brand => brand.id === newBrand.id));
          this.brands = [...this.brands, ...uniqueBrands];

          if (this.allSelectedActive) this.selectedBrand = [...new Set([...this.selectedBrand, ...newBrands])];
        }
    
        this.pagination.page += 1;
        this.lastBrandQuery = query;
      } catch (error) {
        console.error('[BrandMultiselect][getBrands]', error);
      } finally {
        this.loading = false;
      }
    },
    debouncedGetBrands(query) {
      if (this.getBrandsTimeout) clearTimeout(this.getBrandsTimeout);

      this.getBrandsTimeout = setTimeout(
        () => this.getBrands(query),
        700
      );
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedBrand = [];
        this.allSelectedActive = false;
      } else {
        this.selectedBrand = [...this.brands];
        this.allSelectedActive = true;
      }
    },
    limitText(count) { 
      if (this.allSelectedActive){
        this.totalCounter = this.totalBrands - this.deselectedFromAll.length - 1;
      } else {
        this.totalCounter = count;
      }
      return `+ ${this.totalCounter}`;
    },
    clear() {
      this.selectedBrand = []
    },
  },
  computed: {
    deselectedFromAll() {
      if (!this.allSelectedActive) return [];

      return this.brands.filter(brand => !this.selectedBrand.some(selectedBrand => selectedBrand.id == brand.id));
    },
    allSelected() {
      if (this.allSelectedActive && !this.brands.length) return true;

      return (
        this.brands.length &&
        this.selectedBrand.length === this.brands.length
      );
    },
    selectedBrand: {
      get() {
        return this.value;
      },
      set(value) {
        if (Array.isArray(value)) {
          this.$emit('input', value);
        } else {
          const newValue = [...this.value];
          const itemIndex = newValue.findIndex(item => item.id === value.id);
          if (itemIndex !== -1) {
            newValue.splice(itemIndex, 1); 
          }
          else {
            console.log("Item not found for removal:");
          }
          this.$emit('input', newValue);
        }
      }
    },
  }
};
</script>
<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>